import { RemoteNavigation } from './remote-navigation';

/** Bind a presented Ionic alert, keeping its native activation and dismissal. */
export function bindRemoteAlert(alert: HTMLIonAlertElement, prefix: string): () => void {
  const navigation = new RemoteNavigation(alert);
  const buttons = Array.from(alert.querySelectorAll<HTMLButtonElement>('.alert-button'));
  buttons.forEach((button, index) => {
    button.setAttribute('data-remote-focus', '');
    button.setAttribute('data-testid', `${prefix}-${button.classList.contains('alert-button-role-cancel') ? 'cancel' : 'confirm'}-${index}`);
  });
  const moveFocus = (event: KeyboardEvent): void => navigation.moveFocus(event);
  const rememberFocus = (event: FocusEvent): void => navigation.rememberFocus(event);
  const dispose = (): void => {
    navigation.cancelPendingFocus();
    document.removeEventListener('keydown', moveFocus);
    alert.removeEventListener('focusin', rememberFocus);
    alert.removeEventListener('ionAlertWillDismiss', dispose);
  };
  document.addEventListener('keydown', moveFocus);
  alert.addEventListener('focusin', rememberFocus);
  alert.addEventListener('ionAlertWillDismiss', dispose);
  const cancel = buttons.find(button => button.classList.contains('alert-button-role-cancel'));
  if (cancel) void navigation.focusTarget(cancel.getAttribute('data-testid')!);
  return dispose;
}
